/* eslint-disable */

export enum SortOrder {
	RelevancyDesc = 0,
	DisplayName = 1,
	DisplayNameDesc = 2,
	ListPrice = 3,
	ListPriceDesc = 4,
	Popularity = 5,
	ArticleNumber = 6,
	AdminPredictive = 7,
	AdminSale = 8,
	AdminMostSold = 9,
	AdminCreatedDate = 10,
	ModifiedDesc = 11,
	
}
